export const module = {
  info: {
    name: 'system-role-module',
    caption: 'Role Module Assignment',
    viewGroup: 'users'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel'
}

export default module